import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';
import { map } from 'rxjs/operators';
import { scrollEvent } from '../../util/scrollTrack';
import MenuIcon from '../MenuIcon/MenuIcon';
import styles from './Header.module.scss';


export default class Header extends React.Component {
  constructor(props) {
    super(props);
    this.toggleMenu = this.toggleMenu.bind(this);
    this.closeMenu = this.closeMenu.bind(this);
    this.state = {
      menuOpen: false,
      scrollPos: 0,
      hide: false,
    };
  }

  componentDidMount() {
    const headerScrollEvent = scrollEvent.pipe(
      map(() => {
        const { scrollPos } = this.state;
        const topPos = (document.body.getBoundingClientRect()).top;
        this.setState({ scrollPos: topPos });
        return (scrollPos > (0 - 500) || topPos > scrollPos);
      }),
    );

    headerScrollEvent
      .subscribe(show => this.setState(({ menuOpen }) => ({
        hide: !show,
        menuOpen: menuOpen ? false : menuOpen,
      })));
  }

  toggleMenu() {
    this.setState(({ menuOpen }) => ({ menuOpen: !menuOpen }));
  }

  closeMenu() {
    this.setState({ menuOpen: false });
  }

  render() {
    const { title } = this.props;
    const { menuOpen, hide } = this.state;

    const headerClasses = [
      styles.header,
      menuOpen && styles.menuOpen,
      hide && styles.hide,
    ].join(' ');

    const createNavLink = (path, label) => (
      <Link to={path}>{label}</Link>
    );

    return (
      <Fragment>
        <div className={styles.wrapper}>
          <header className={headerClasses}>
            <div className={styles.navigationHeader}>
              <Link className={styles.titleWrapper} to="/"><h1 className={styles.title}>{title}</h1></Link>
              <MenuIcon
                className={styles.menuIcon}
                open={menuOpen}
                onClick={this.toggleMenu}
              />
              <ul className={styles.menu}>
                <li>{createNavLink('/#about', 'About')}</li>
                <li>{createNavLink('/gallery', 'Gallery')}</li>
                <li>{createNavLink('/trailer', 'Trailer')}</li>
                <li>{createNavLink('/#contact', 'Contact')}</li>
              </ul>
            </div>
          </header>
        </div>
      </Fragment>
    );
  }
}

Header.propTypes = {
  title: PropTypes.string.isRequired,
};